<template>
    <div class="hero-carousel">
        <swiper :options="swiperOption">
            <swiper-slide class="slide" v-for="i in slidesNumber" :style="slidesBackground.length > 0 ? 'background-image:' + slidesBackground[i-1] : 'background: '">
                <div class="intro__container">
                    <slot :name="`slide${showExtraSlide ? i-1 : i}`"></slot>
                </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-buttons-container" v-if="isDesktopView">
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </div>
        </swiper>
        <slot></slot>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import { heroDataHelper } from 'components/landingpage/hero/heroDataHelper'
    require('swiper/dist/css/swiper.css')

    export default {
        name: 'hero-carousel',
        components: {
            swiper,
            swiperSlide
        },
        mixins: [heroDataHelper],
        props: {
            slidesBackground: {
                type: Array,
                default: () => []
            }
        },
        computed: {
            swiperOption () {
                return {
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    autoplay: {
                        delay: 8000,
                        disableOnInteraction: true,
                        pauseOnMouseEnter: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    effect: 'fade',
                    loop: false
                }
            },
            showExtraSlide () {
                return false
            }
        }
    }
</script>

<style lang="scss" scoped>
.hero-carousel {
    width: 100%;

    [class*="desktop"] & {
        position: relative;
        top: -80px;
        height: 506px;
        overflow: visible;
    }
}

.intro {
    &__container {
        padding: 65px 20px 30px;
        width: 100%;
        height: 100%;

        [class*="desktop"] & {
            padding: 0 90px;
        }

        [class*="desktop_xxxl"] & {
            max-width: 1648px;
            margin: 0 auto;
        }
    }

    &__image-box {
        padding: 20px 0;
        order: -1;
        width: 50%;
        flex: 0 0 40%;

        [class*="desktop"] & {
            padding: 67px 0 0;
            order: 1;
            width: 100%;
        }

        [class*="desktop_xxl"] & {
            flex: 0 0 30%;
        }

        [class*="desktop_xxxl"] & {
            flex: 0 0 25%;
        }
    }

    &__image {
        width: 100%;
        margin: 0 0 -4px;
    }
}

.swiper-container {
    height: 100%;
    overflow: visible;
}

.swiper-buttons-container {
    position: absolute;
    width: 100%;
    left: 50%;
    top: calc(50% + 40px);
    transform: translate(-50%);
    z-index: 1;

    [class*="desktop_xxxl"] & {
        max-width: 1648px;
        margin: 0 auto;
    }
}

.slide {
    background-repeat: no-repeat;
    background-size: cover;
    background-color: $light_blue;
    color: white;
    display: flex;
    align-items: flex-start;
    font-size: 3rem;
    height: 100%;
    width: 100%;

    [class*="desktop"] & {
        padding: 80px 0 0 0;
        align-items: center;
    }
}

.swiper-container-horizontal {
    & > .swiper-pagination-bullets {
        width: auto;
        top: 30px;
        bottom: auto;

        [class*="desktop"] & {
            top: 90px;
        }
    }
}

.swiper-button-prev,
.swiper-button-next {
    top: 50%;
    transform: translateY(-50%);
    bottom: auto;
    font-size: 5rem;
    color: $lavender;
    border-radius: 5px;
    height: 80px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:focus {
        outline: none;
    }

    &:hover {
        color: $stratos;
    }
}
</style>

<style lang="scss">
.swiper-pagination {
    & > .swiper-pagination-bullet {
        background: $lavender !important;
        opacity: 0.3 !important;
    }

    & > .swiper-pagination-bullet-active {
        opacity: 1 !important;
    }
}
</style>
